import { ChangeDetectionStrategy,AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, signal, WritableSignal, ModelSignal, model } from '@angular/core';
import { CommentService, WorkItemComment } from 'src/app/api/comment.service';

@Component({
    selector: 'app-work-item-comment',
    templateUrl: './work-item-comment.component.html',
    styleUrls: ['./work-item-comment.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkItemCommentComponent implements OnInit, AfterViewInit {


  private _workItemId: number = 0;


  @Input() set workItemId(id: number) {
    this._workItemId = id;
  }
  
  get workItemId(): number {
    return this._workItemId;
  }

  @Output() commentSaved = new EventEmitter<WorkItemComment>();

  @ViewChildren("commentBox") textarea!: QueryList<ElementRef>

  commentVisible: WritableSignal<boolean> = signal(false);
  commentText: ModelSignal<string> = model("");

  constructor(
    private commentService: CommentService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.textarea.changes.subscribe(() => {
      this.textarea.forEach(element => {
        element.nativeElement.focus();
      });
    })
  }

  saveComment() {
    this.commentService.addComment(this.workItemId, this.commentText()).subscribe((newComment) => {
      this.hideCommentBox()
      this.commentSaved.emit(newComment);
    })
  }

  displayCommentBox() {
    this.commentVisible.set(true);

  }

  hideCommentBox() {
    this.commentVisible.set(false);
    this.commentText.set("");
  }

}
